import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'lib-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  currentYear = new Date().getFullYear();
  socialAccountsLinks = [
    {title: 'Like us on Facebook', tag: 'home_facebook_icon', href: "https://www.facebook.com/JoinQatch/", icon: 'facebook' },
    {title: 'Follow us on Tiktok', tag: 'home_tiktok_icon', href: "https://www.tiktok.com/@joinqatch", icon: 'tiktok' },
    {title: 'Follow us on Instagram', tag: 'home_instagram_icon', href: "https://www.instagram.com/joinqatch/", icon: 'instagram' },
    {title: 'Follow us on LinkedIn', tag: 'home_linkedin_icon', href: "https://www.linkedin.com/company/joinqatch/", icon: 'linkedin' }
  ];
  qatchPagesLinks = [
    { title: 'How It Works', tag: 'home_how_it_works_footer', path: '/how-it-works'},
    { title: 'About Us', tag: 'home_about_us_footer', path: '/our-story'},
    { title: 'Contact Us', tag: 'home_contact_footer', path: '/contact-us'},
    { title: 'Sign In', tag: 'home_signin_footer', path: '/signin'}
  ];
  outerPagesLinks = [
    { title: 'Partnerships', tag: 'partnership_footer', href: `https://qatch.net`},
  ];
  
  constructor() { }

}
